import superagent from 'superagent'
import ReactGA from 'react-ga'

export const login = auth => {
  return {
    type: 'LOGIN',
    payload: auth
  }
}
export const logout = () => {
  return { type: 'LOGOUT' }
}

export const expiredTokenLogout = () => {
  return { type: 'EXPIRED_TOKEN_LOGOUT' }
}

export const facebokLoginRequest = fbAuthObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with FaceBook'
  })
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/auth/fbauth`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(fbAuthObj))
      .end((err, res) => {
        if (err) {
          $('.facebook-button').show()
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.fbAuth = true
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{facebook}')
            })
          }, 3000)
          resolve(err, res.body)
          dispatch(login(token.accessToken))
        }
      })
  })
}

export const facebookLoginRequestFreeTrial = fbAuthObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Facebook free trial'
  })
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/auth/fbauth?var=Eastmans`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(fbAuthObj))
      .end((err, res) => {
        if (err) {
          $('.facebook-button').show()
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.fbAuth = true
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{facebook}')
            })
          }, 3000)
          resolve(err, res.body)
          dispatch(login(token.accessToken))
        }
      })
  })
}

export const googleLoginRequest = googleAuthObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Google'
  })
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/Auth/GoogleAuth`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(googleAuthObj))
      .end((err, res) => {
        if (err) {
          console.log(`ERROR: ${__API_URI__}/Auth/GoogleAuth ` + err)
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.GoogleAuth = true
          dispatch(login(token.accessToken))
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{google}')
            })
          }, 3000)
          resolve(err, res.body)
        }
      })
  })
}

export const googleLoginRequestFreeTrial = googleAuthObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Google Free Trial'
  })
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/Auth/GoogleAuth?var=Eastmans`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(googleAuthObj))
      .end((err, res) => {
        if (err) {
          console.log(`ERROR: ${__API_URI__}/Auth/GoogleAuth?var=Eastmans` + err)
        } else {
          let token = JSON.parse(res.text)
          token.accessToken.GoogleAuth = true
          dispatch(login(token.accessToken))
          setTimeout(() => {
            let user = getState().user
            Countly.q.push(() => {
              Countly.user_details({
                name: `${user.fullName}`,
                email: `${user.email}`
              })
              Countly.userData.increment('Login', '1')
              Countly.userData.set('LoginSource', '{google}')
            })
          }, 3000)
          resolve(err, res.body)
        }
      })
  })
}

export const authLoginRequest = bmAuthObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Logged in with Auth'
  })
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/auth/auth`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(bmAuthObj))
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          trackLogin(res.body.fullName, res.body.email)
          dispatch(login(res.body.accessToken))
          resolve(res.body)
        }
      })
  })
}

export const authRefreshRequest = (currentTimout, logOutCallback) => (dispatch, getState, token) => {
  let refreshToken = getState().auth.refreshToken
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/auth/refresh/${refreshToken}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          // If token already expired
          if (res.status == 401 || res.status == 400) {
            // logOutCallback()
            reject()
          }
        } else {
          let token = res.body
          // currentTimout(token.expiresSeconds)
          resolve(res.body)
          dispatch(login(token))
        }
      })
  })
}

export const createUserRequest = UserObj => (dispatch, getState) => {
  ReactGA.event({
    category: 'User',
    action: 'Created an Account'
  })
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/user/create`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(UserObj))
      .end((err, res) => {
        if (err) {
          reject(err)
        }
        let token = res.body
        trackLogin(res.body.fullName, res.body.email)
        trackCreate()
        resolve(res.body)
        dispatch(login(token.accessToken))
      })
  })
}

const trackLogin = (name, email) => {
  Countly.q.push(() => {
    Countly.user_details({
      name: `${name}`,
      email: `${email}`
    })
    Countly.userData.increment('Login', '1')
    Countly.userData.set('LoginSource', '{password}')
  })
}

const trackCreate = () => {
  Countly.q.push([
    'add_event',
    {
      key: 'Create Account',
      count: 1,
      segmentation: {
        'Action Type': 'Account Created'
      }
    }
  ])
}
